import 'react';
import { BsViewList } from '@react-icons/all-files/bs/BsViewList';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Accordion as Accordion$1 } from './Accordion.js';
import { AccordionInspector } from './Accordion.Inspector.js';
import { jsx } from '@emotion/react';

var AccordionExpandButtonNode = {
  key: null,
  type: 'accordionButton',
  props: {
    action: 'expand'
  },
  children: []
};
var AccordionCollapseButtonNode = {
  key: null,
  type: 'accordionButton',
  props: {
    action: 'collapse'
  },
  children: []
};
var AccordionContentNode = {
  key: null,
  type: 'accordionContent',
  props: {},
  children: []
};
var Accordion = decorateComponent(Accordion$1, 'block', {
  id: 'accordion',
  label: '아코디언',
  defaultProps: {
    buttonPlacement: 'bottom',
    children: [AccordionExpandButtonNode, AccordionCollapseButtonNode, AccordionContentNode]
  },
  allowedChildren: [],
  disallowedAncestors: ['a', 'coupon', 'tabButton', 'carousel', 'accordion'],
  renderIcon: function renderIcon() {
    return jsx(BsViewList, null);
  },
  renderInspector: AccordionInspector
});

export { Accordion as default };
//# sourceMappingURL=index.js.map
